import React, { useCallback, useMemo } from 'react';
import ItemContent from '../../../components/ItemContent/ItemContent';
import { IEditForm } from '../../../types/interfaces/IEditForm';
import { NSPackages } from '../../../types/interfaces/NSPackages';
import { EStatus } from '../../../types/enums/EStatus';
import { useTranslation } from 'react-i18next';
import countriesJSON from '../../../assets/countries/countries.json';
import tPaths from '../../../utils/tPaths';
import { endpoints } from '../../../utils/endpoints';
import { EPaths } from '../../../types/enums/EPaths';

const AddCustomer = () => {
  const { t } = useTranslation();

  const dataMapper = useCallback((): IEditForm[][] => {
    return [
      [
        {
          type: 'input',
          fieldName: 'name',
          label: t(tPaths.editFormLabels.name),
          initialValue: '',
        },
        {
          type: 'input',
          fieldName: 'email',
          label: t(tPaths.editFormLabels.email),
          initialValue: '',
        },
        {
          type: 'select',
          fieldName: 'country',
          label: t(tPaths.editFormLabels.country),
          variants: countriesJSON.map((country) => ({
            value: country['alpha-3'],
            label: country.name,
          })),
        },
        {
          type: 'createPassword',
          fieldName: 'password',
          label: t(tPaths.editFormLabels.password),
          initialValue: '',
        },
        {
          type: 'switch',
          fieldName: 'athlete',
          label: t(tPaths.editFormLabels.athlete),
          initialValue: true,
        },
      ],
    ];
  }, [t]);

  const updateDataFormatter = useCallback(
    (fields: any) => ({
      name: fields.name.value,
      email: fields.email.value,
      status: fields.status ? EStatus.Active : EStatus.Inactive,
      password: fields.password.value,
      athlete: fields.athlete.value,
      country: fields.country.value,
    }),
    [],
  );

  const switches = useMemo(() => [{ key: 'status', label: t(tPaths.itemContent.active) }], [t]);
  const switchesDataMapper = useCallback((data: NSPackages.IPackageDetails) => {
    return { status: data.status.current === EStatus.Active };
  }, []);

  return (
    <ItemContent
      title={t(tPaths.itemContent.addCustomer)}
      path={EPaths.Customers}
      contentMapper={dataMapper}
      updateDataFormatter={updateDataFormatter}
      switches={switches}
      switchesDataMapper={switchesDataMapper}
      addItem={true}
      apiUrl={endpoints.customers}
    />
  );
};

export default AddCustomer;
